<app-auth-navbar></app-auth-navbar>

<main class="rtl">
    <div class="relative pt-16 pb-32 flex content-center items-center justify-center">
        <div class="bg-primary absolute top-0 w-full h-20 bg-center bg-cover">
            <span class="w-full h-full absolute" id="blackOverlay"></span>
        </div>
        <div class="container relative mx-auto pt-20">
            <div class="items-center flex flex-wrap">

                <div class="w-full mx-auto px-2">
                    <div class="py-6">
                        <div class="md:w-[80%] xs:w-[90%] min-h-screen-50 mx-auto pt-4">
                            <h2 class="text-3xl font-semibold my-4"> قوانین و مقررات </h2>
                            <p class="mx-auto text-md dark:text-gray-300" [innerHTML]="terms.siteRules">

                            </p>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</main>


<app-footer></app-footer>